import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTestBuyClean = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "m17 3-1-3-1 3-3 1 3 1 1 3 1-3 3-1-3-1Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M9 2.5 6.2 8.2.5 11l5.7 2.8L9 19.5l2.8-5.7 5.7-2.8-5.7-2.8L9 2.5ZM7.7 9.7 9 7l1.3 2.7L13 11l-2.7 1.3L9 15l-1.3-2.7L5 11l2.7-1.3Z",
		clipRule: "evenodd"
	})]
});
export default SvgTestBuyClean;
